module.exports = __webpack_public_path__ + "img/aroolla-logo-color.0894073a.svg";